// @ts-check
// Páginas de e-mail do menu Campanhas, montadas por client/src/app/app.js (spec-2.0.0 seção 4.10; contrato 09 de
// e-mail): a lista e a campanha v2 (frente 2A) e a página do modelo de e-mail (frente 1C, email-template-page.js).
import { html } from 'htm/preact';
import { CampaignsPage } from './campaigns-page.js';
import { CampaignEditorPage } from './campaign-editor-page.js';
import { EmailTemplatePage } from './email-template-page.js';

/**
 * Objetos que podem ser público de campanha de e-mail pela lista ou pela seleção (comandos list.emailCampaign e
 * selection.emailCampaign): na 2.0.0 o público é o card do funil ([PUB]).
 * @type {ReadonlySet<string>}
 */
export const EMAIL_CAMPAIGN_OBJECT_NAMES = new Set(['enrollmentOpportunity']);

/** Lista das campanhas de e-mail (/campaigns/email). */
export function EmailCampaignListPage() {
  return html`<${CampaignsPage} />`;
}

/** Campanha de e-mail (/campaigns/email/:campaignId). @param {{ campaignId: string }} props */
export function EmailCampaignDetailPage({ campaignId }) {
  return html`<${CampaignEditorPage} campaignId=${campaignId} />`;
}

/**
 * Modelo de e-mail novo ou existente (/campaigns/templates/email/new e /campaigns/templates/email/:templateId).
 * @param {{ templateId: string | null }} props
 */
export function EmailTemplateEditorPage({ templateId }) {
  return html`<${EmailTemplatePage} templateId=${templateId} />`;
}
